<template>
    <div class="corpo-pagina">
      <div class="row row-text">
        <div class="col s12">
          <h4>{{ this.translation.getters.traduzione('title.reset.password') }}</h4>
        </div>
      </div>

      <div class="row row-text">
        <div class="col s12">
          <p>{{ this.translation.getters.traduzione('msg.page.ripristino.password') }}</p>
        </div>
      </div>

      <div class="divider"></div>

      <div class="row">
        <div class="col s12 m7 l7">
          <form class="col s12 filed-box">
            <div>
              <p v-html="this.translation.getters.traduzione('password.langh.label')"></p>
              <div class="input-field">
                <i class="material-icons prefix">vpn_key</i>
                <input type="password" v-model="form.password" class="validate required" id="password" autocomplete="off">

                <label for="password">{{ this.translation.getters.traduzione('filed.password') }}</label>
                <span class="password-toggle">
                  <i class="material-icons" @click="showPassword1 = !showPassword1">{{ showPassword1 ? 'visibility_off' : 'visibility' }}</i>
                </span>
                <span id="error-message-password" class="error-message-style nodipslay">
                    {{ this.translation.getters.traduzione('filed.required.validation') }}
                </span>
              </div>
            </div>
          </form>
        </div>
        <div class="col s12 m5 l5"></div>
      </div>

      <div class="row">
        <div class="col s12 m7 l7">
          <form class="col s12 filed-box">
            <div>
              <div class="input-field">
                <i class="material-icons prefix">vpn_key</i>
                <input type="password" v-model="form.password_confirmation" class="validate required" id="passworda" autocomplete="off">
                <label for="passworda">{{ this.translation.getters.traduzione('filed.password.confirm') }}</label>
                <span class="password-togglea">
                  <i class="material-icons" @click="showPassword2 = !showPassword2">{{ showPassword2 ? 'visibility_off' : 'visibility' }}</i>
                </span>
                <span id="error-message-passworda" class="error-message-style nodipslay">
                    {{ this.translation.getters.traduzione('filed.required.validation') }}
                </span>
              </div>
            </div>
          </form>
        </div>
        <div class="col s12 m5 l5"></div>
      </div>

      <div class="row">
        <div class="col s12 m4 l4">
          <a href="javascript:void(0)" class="btn-large" @click="attiva()">
            <i class="material-icons left">save</i>
            {{ this.translation.getters.traduzione('btn.reset.password.mail') }}
          </a>
        </div>
        <div class="col s12 m8 l8"></div>
      </div>
    </div>

  </template>
<script>
import { passwordModel } from '@/models/passwordModel.js'
import apiService from '@/services/apiService.js'
import translationStore from '@/store/translations'
import loadingStore from '@/store/loading'

export default {
  data () {
    return {
      form: {
        password: '',
        password_confirmation: ''
      },
      modelPassw: { ...passwordModel }, // Potresti non aver bisogno di questo
      tk: null,
      email: null,
      translation: translationStore,
      showPassword1: false,
      showPassword2: false
    }
  },
  methods: {
    async chekUser () {
      loadingStore.commit('setLoading', true)
      this.tk = this.$route.query.tk
      this.email = this.$route.query.email
      loadingStore.commit('setLoading', false)
    },

    insertPassword () {
      loadingStore.commit('setLoading', true)
      const pwd = this.generaPasswordSicura(8)
      const elem = document.getElementById('password')
      elem.valus = pwd
      loadingStore.commit('setLoading', false)
    },

    generaPasswordSicura (lunghezza = 12) {
      loadingStore.commit('setLoading', true)
      const caratteriMinuscoli = 'abcdefghijklmnopqrstuvwxyz'
      const caratteriMaiuscoli = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const cifre = '0123456789'
      const caratteriSpeciali = '@$!%?&.'
      const tuttiICaratteri = caratteriMinuscoli + caratteriMaiuscoli + cifre + caratteriSpeciali

      if (lunghezza < 8) {
        const msg = this.translation.getters.traduzione('error.password.lunghezza')
        throw new Error(msg)
      }

      const password = []

      // Assicurati che ci sia almeno un carattere di ogni tipo richiesto
      password.push(caratteriMinuscoli[Math.floor(Math.random() * caratteriMinuscoli.length)])
      password.push(caratteriMaiuscoli[Math.floor(Math.random() * caratteriMaiuscoli.length)])
      password.push(cifre[Math.floor(Math.random() * cifre.length)])
      password.push(caratteriSpeciali[Math.floor(Math.random() * caratteriSpeciali.length)])

      // Riempi il resto della password con caratteri casuali
      for (let i = 0; i < lunghezza - 4; i++) {
        password.push(tuttiICaratteri[Math.floor(Math.random() * tuttiICaratteri.length)])
      }

      // Mescola la password per renderla più casuale
      for (let i = password.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [password[i], password[j]] = [password[j], password[i]]
      }
      loadingStore.commit('setLoading', false)
      return password.join('')
    },

    blocForm (fields) {
      loadingStore.commit('setLoading', true)
      const allElements = document.querySelectorAll('*') // Seleziona tutti gli elementi nel DOM
      const msgElements = document.querySelectorAll('.error-message-style')

      allElements.forEach(element => {
        if (element.classList.contains('invalid')) {
          element.classList.remove('invalid')
        }
        if (element.classList.contains('invalid-icon')) {
          element.classList.remove('invalid-icon')
        }
      })

      msgElements.forEach(element => {
        element.classList.add('nodipslay')
      })

      Object.values(fields).forEach(valore => {
        const elem = document.getElementById(valore.field)

        if (elem && this.isVisibleComputedStyle(elem)) {
          elem.classList.add('invalid')
          const prefixIcon = elem.previousElementSibling

          // Gestione specifica per gli elementi <select> di Materialize
          if (elem.tagName.toLowerCase() === 'select') {
            const selectWrapper = elem.parentNode.querySelector('.select-wrapper input.select-dropdown')
            if (selectWrapper) {
              selectWrapper.classList.add('invalid')

              const iconInvalid = document.getElementById('select-icon-' + valore.field)
              iconInvalid.classList.add('invalid-icon')
            }
          }

          if (prefixIcon && prefixIcon.classList.contains('prefix')) {
            prefixIcon.classList.add('invalid-icon')
          }

          const msg = document.getElementById('error-message-' + valore.field)
          if (msg) {
            msg.classList.remove('nodipslay')
          }
        }
      })
      loadingStore.commit('setLoading', false)
    },
    isVisibleComputedStyle (element) {
      const style = window.getComputedStyle(element)
      return style.display !== 'none' && style.visibility !== 'hidden'
    },

    async validateForm () {
      const fields = []
      const p = document.getElementById('password')
      const c = document.getElementById('passworda')
      let ris = true

      const regeValid = this.$validatePassword(p.value)
      if (!regeValid) {
        fields.push({ field: p.getAttribute('id') })
      } else {
        const err = this.$validateSamePassword(p.value, c.value)
        if (!err) {
          fields.push({ field: c.getAttribute('id') })
        }
      }

      const lvalid = fields.length

      if (lvalid >= 1) {
        ris = false
        this.blocForm(fields)
      }

      return ris
    },

    async attiva () {
      const valid = await this.validateForm()

      if (valid) {
        try {
          const token = await apiService.getClientCredentialsToken()

          const url = process.env.VUE_APP_URL_USER + '/user/resetnewpassword'
          const payload = { token: this.tk, email: this.email, pwd: this.form.password } // Usa form.password
          const jsonCntry = await apiService.sendRequestWithBearer('POST', url, token, payload)

          if (jsonCntry) {
            this.$router.push('/recover-password/finish')
          } else {
            this.$router.push('/error')
          }
        } catch (error) {
          this.$router.push('/error')
        }
      }
    }
  },
  mounted () {
    this.chekUser()
    this.$nextTick(() => {
      const passwordInput = document.getElementById('password')
      const passwordToggle = document.querySelector('.password-toggle')

      if (passwordToggle) {
        passwordToggle.addEventListener('click', function () {
          const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password'
          passwordInput.setAttribute('type', type)
          this.querySelector('i').textContent = type === 'password' ? 'visibility' : 'visibility_off'
        })
      }

      const passwordInputa = document.getElementById('passworda')
      const passwordTogglea = document.querySelector('.password-togglea')

      if (passwordTogglea) {
        passwordTogglea.addEventListener('click', function () {
          const type = passwordInputa.getAttribute('type') === 'password' ? 'text' : 'password'
          passwordInputa.setAttribute('type', type)
          this.querySelector('i').textContent = type === 'password' ? 'visibility' : 'visibility_off'
        })
      }
    })
    loadingStore.commit('setLoading', false)
  }
}
</script>
  <style>
  .input-field {
    position: relative;
  }

  .password-toggle,
  .password-togglea {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    cursor: pointer;
    user-select: none;
  }

  .password-toggle i,
  .password-togglea i {
    color: #757575;
  }
  </style>
